import { FormProvider, FormProviderProps } from 'react-hook-form';

import { DemandRecommendationFormData } from '../DemandRecommendationForm/DemandRecommendationForm.schema';

import { RecommendationFormContext } from './RecommendationFormProvider.context';

export type RecommendationFormContextStateType = {
  isFormActive: boolean;
};

interface RecommendationFormProviderProps extends FormProviderProps<DemandRecommendationFormData, any> {
  isActive: boolean;
}

export const RecommendationFormProvider = ({ isActive, children, ...props }: RecommendationFormProviderProps) => {
  return (
    <RecommendationFormContext.Provider value={{ isFormActive: isActive }}>
      <FormProvider {...props}>{children}</FormProvider>
    </RecommendationFormContext.Provider>
  );
};
